<template>
  <h1>Lay-By Component</h1>
</template>

<script lang="ts" setup></script>
